import { Button, Popconfirm, Rate } from "antd";

export const getColumns = ({ handleDeleteReview }) => [
  {
    title: "Room Name",
    dataIndex: "roomName",
    key: "roomName",
  },
  {
    title: "Booking ID",
    dataIndex: "bookingId",
    key: "bookingId",
    render: (bookingId) => bookingId || "N/A", // Handle cases where bookingId might be missing
  },
  {
    title: "Guest Name",
    dataIndex: "guestName",
    key: "guestName",
  },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
    render: (rating) => <Rate value={rating} disabled />,
  },
  {
    title: "Comment",
    dataIndex: "comment",
    key: "comment",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date) => new Date(date).toLocaleDateString(),
  },
  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <Popconfirm
        title="Are you sure to delete this review?"
        onConfirm={() => handleDeleteReview(record.roomId, record._id)}
        okText="Yes"
        cancelText="No"
      >
        <Button type="link" danger>
          Delete
        </Button>
      </Popconfirm>
    ),
  },
];
